import React from 'react'
import { Offcanvas } from 'react-bootstrap'
import { setShowAuditLog } from '../../../store/slices/dashboardSlice'

import { useAppDispatch, useAppSelector } from '../../../store/store'
import { DeviceProfileId } from '../../../shared/models/id/device-profile-id'
import AuditLogHome from '../../../pages/audit-log/AuditLogHome'

interface Props {
  open: boolean
}

const CanvasAuditLogs = ({ open }: Props) => {
  // App dispatcher
  const dispatch = useAppDispatch()
  const currentDashboard = useAppSelector((state) => state.dashboard)
  return (
    <>
      <Offcanvas
        show={open}
        placement={'end'}
        className={'canvas-wide'}
        onHide={() => {
          dispatch(setShowAuditLog())
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h4 className={'text-primary'}>Audit Logs</h4>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className={''}>
          <AuditLogHome
            entityID={currentDashboard.id}
            hiddenColumns={['id', 'entityID']}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default CanvasAuditLogs
